import type AddToWalletButtonProps from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function AddToWalletButton(_props: AddToWalletButtonProps) {
    return null;
}

AddToWalletButton.displayName = 'AddToWalletButton';

export default AddToWalletButton;
